import { ConfirmSalaryModal } from './ConfirmSalaryModal.main';

export { ConfirmSalaryModal };
